import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getLogicCheckerCategoryResults';

export const getLogicCheckerCategoryResults = (params, endpoint = ENDPOINT) => {
    return network.post(endpoint, params).then((response) => {
        return response.data;
    });
};
